import { useArticleTimeline } from './useArticleTimeline'
import { useAuthOrUnregisteredUser } from './useAuthOrUnregisteredUser'
import { ActivityEvent } from 'components/ActivityEvent/Types'
import { TimelineEventType } from 'screens/Activity/Types'
import { FetchRequestState } from 'types'
import { TimelineEventFilter } from 'api/clients/ArticleClient'
import dayjs from 'dayjs'
import { useRef } from 'react'

interface Props {
  articleId: string
  layerId: string
  initialFilters?: TimelineEventFilter[]
}

export const useLastEvent = ({ articleId, layerId, initialFilters }: Props) => {
  const timestamp = useRef(dayjs().toISOString())
  const auth = useAuthOrUnregisteredUser().user
  const { timeline, initialLoadingState } = useArticleTimeline(
    articleId,
    {
      userId: auth?.id.toString(),
      receiveRealtimeUpdates: true,
      skip: false,
    },
    layerId,
    initialFilters,
    timestamp.current,
  )

  const loading = initialLoadingState === FetchRequestState.Loading

  if (initialLoadingState === FetchRequestState.Rejected) return { lastAiEvent: undefined, loading }

  return {
    lastEvent:
      (timeline?.events.filter((event) => event.type !== TimelineEventType.ArticleLastViewed)[0] as ActivityEvent) ||
      undefined,
    loading,
  }
}
